





















































import { DocumentReviewPatch } from "@/types/document/documentReviewerPatch";
import { DocumentReviewState } from "@/enums";
import { updateDocumentReviewAsync } from "@/documents";
import { DocumentInfo, settingName, User } from "@infoland/iprova-api";
import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import storeHelper from "@/store/store-helper";
import { ActionResult } from "@/store/modules/document/document";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ApproveDocumentReview",
    props: {
        documentProperties: Object as () => DocumentInfo,
        passwordRequired: Boolean
    },
    data: function () {
        return {
            password: null as string,
            twoFactorCode: null as string,
            show: false,
            invalidPassword: false,
            invalidPasswordText: null as string,
            samlEnabled: null as boolean
        };
    },
    created() {
        this.registerHandlers({ ok: this.oKClicked });
        this.isSAMLEnabled();
    },
    computed: {
        requiredRule() {
            return (v: string) => Boolean(v) || this.$t("general.validation.isRequired");
        },
        invalidPasswordRule(): boolean | String {
            if (this.invalidPassword) return this.invalidPasswordText;
            return true;
        },
        twoStepRequired(): boolean {
            const inGracePeriod = this.$user.two_step_deadline_datetime && this.$user.two_step_deadline_datetime.toDate() >= new Date();
            return this.$user.two_step_authentication_allowed && !inGracePeriod;
        }
    },
    methods: {
        async oKClicked(): Promise<boolean> {
            if (!this.passwordRequired || (this.passwordRequired && this.validateForm())) {
                const result = await this.approveReview();
                if (result.success) {
                    this.$emit("approved");
                    storeHelper.siteStore.setSnackBarMessageLookup("document.review.successfullMessage", false);
                    return true;
                } else if (result.errorData) {
                    this.invalidPassword = true;
                    this.invalidPasswordText = this.$t("document.review.errorMessages." + result.errorData).toString();
                }
                return false;
            }
            return false;
        },
        validateForm(): boolean {
            return (this.$refs.form as Vue & { validate: () => boolean }).validate();
        },
        async approveReview(): Promise<ActionResult<void, string>> {
            const documentReviewPatch = {
                state: DocumentReviewState.approved,
                password: this.password,
                two_factor_code: this.twoFactorCode
            } as DocumentReviewPatch;
            const result = await updateDocumentReviewAsync(
                this.documentProperties.document_id,
                this.documentProperties.version,
                this.$user.user_id,
                documentReviewPatch
            );
            return result;
        },
        async isSAMLEnabled() {
            let autoLogin = await storeHelper.settingsStore.getSettingAsync<string>(settingName.autologin);
            this.samlEnabled = autoLogin == "saml2";
        }
    }
});
